import Doars from './DoarsCall.js'

window.Doars = Doars
